module.exports = __webpack_public_path__ + "img/order-processed.0f038a19.svg";